import { render, staticRenderFns } from "./CampaignStepTemplate.vue?vue&type=template&id=0bd61aa9&scoped=true&"
import script from "./CampaignStepTemplate.vue?vue&type=script&lang=js&"
export * from "./CampaignStepTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStepTemplate.vue?vue&type=style&index=0&id=0bd61aa9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd61aa9",
  null
  
)

export default component.exports